import AutocompleteBase from 'components/forms/fields/autocomplete-field/autocomplete-base/autocomplete-base.component';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const AmountTypeSelect = ({ name, transaction, refundableAmountValue }) => {
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  const onChange = (_e, value) => {
    const isPartialAmount = value.id === 'partialAmount';
    setValue(name, isPartialAmount);

    if (!isPartialAmount) {
      setValue('refundAmount', (refundableAmountValue / 1000).toFixed(2), {
        shouldValidate: true,
      });
    }
  };

  const options = [
    {
      id: 'partialAmount',
      label: t(
        'forms.fields.refundForm.amountTypeSelect.options.partialAmount.label',
      ),
    },
    {
      id: 'fullAmount',
      label: t(
        'forms.fields.refundForm.amountTypeSelect.options.fullAmount.label',
      ),
    },
  ];

  return (
    <AutocompleteBase
      disableClearable
      defaultValue={options[0]}
      data-testid="RefundForm.AmountTypeSelect"
      options={options}
      onChange={onChange}
      TextFieldProps={{
        label: t('forms.fields.refundForm.amountTypeSelect.label'),
      }}
      isOptionEqualToValue={(option, value) => option.id === value.id}
    />
  );
};

export default AmountTypeSelect;
